import React, { useState } from 'react';
import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip, Legend } from 'recharts';

const PipelineDonutChart = ({ data }) => {
  const [activeIndex, setActiveIndex] = useState(null);

  const CustomTooltip = ({ active, payload }) => {
    if (active && payload && payload?.length) {
      return (
        <div className="bg-card border border-border rounded-lg p-3 shadow-lg">
          <p className="text-sm font-medium text-foreground mb-1">{payload?.[0]?.name}</p>
          <p className="text-xs text-muted-foreground">Deals: {payload?.[0]?.payload?.deals}</p>
          <p className="text-xs text-muted-foreground">Percentage: {payload?.[0]?.value}%</p>
        </div>
      );
    }
    return null;
  };

  const onPieEnter = (_, index) => {
    setActiveIndex(index);
  };

  const onPieLeave = () => {
    setActiveIndex(null);
  };

  return (
    <div className="bg-card rounded-2xl p-4 md:p-6 shadow-elevation-2">
      <div className="mb-4">
        <h3 className="text-xl font-semibold text-foreground mb-1">Pipeline Distribution</h3>
        <p className="text-sm text-muted-foreground">Deal distribution across stages</p>
      </div>
      <div className="h-[300px] md:h-[350px]">
        <ResponsiveContainer width="100%" height="100%">
          <PieChart>
            <Pie
              data={data}
              cx="50%"
              cy="50%"
              innerRadius={60}
              outerRadius={100}
              paddingAngle={2}
              dataKey="value"
              onMouseEnter={onPieEnter}
              onMouseLeave={onPieLeave}
            >
              {data?.map((entry, index) => (
                <Cell
                  key={`cell-${index}`}
                  fill={entry?.color}
                  opacity={activeIndex === null || activeIndex === index ? 1 : 0.6}
                  style={{ transition: 'opacity 0.3s' }}
                />
              ))}
            </Pie>
            <Tooltip content={<CustomTooltip />} />
            <Legend
              verticalAlign="bottom"
              height={36}
              iconType="circle"
              formatter={(value, entry) => (
                <span className="text-sm text-foreground">
                  {value} ({entry?.payload?.deals})
                </span>
              )}
            />
          </PieChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

export default PipelineDonutChart;